import React from "react";
import { Col, Row, Form, button, Alert } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { REACHUS_FORM_API } from "../../config/config";
export const ReachusForm = ({ h1text }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      phone_number: "",
      email: "",
      city: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Full name must contain only letters")
        .min(3, "Full name must be at least 3 characters")
        .required("Full name is required"),
      phone_number: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),
      email: Yup.string()
        .matches(/^[^@]+@[^@]+\.[a-zA-Z]{2,}$/, "Please enter a valid Email ID")
        .required("Email ID is required"),

      city: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "City name must contain only letters")
        .required("City is required"),

      message: Yup.string()
        .required("Message is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await axios.post(REACHUS_FORM_API, values);
        formik.setStatus({ success: response.data.message });
        toast.success(
          response.data.message ||
          "Your enquiry has been successfully submitted!",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        resetForm();
      } catch (error) {
        toast.error("Error submitting the form", {
          position: "top-right",
          autoClose: 3000,
        });
        formik.setStatus({ error: "Error submitting the form" });
        console.error("Error submitting the form:", error);
      }
    },
  });
  return (
    <Col>
      <Form onSubmit={formik.handleSubmit} className="reachus-text">
        <div className="h1 text-start mb-2 them-font">{h1text}</div>
        <Row>
          <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6} className="mt-1">
            <Form.Group controlId="formFullName" className="">
              <Form.Label className="reatch-us-form-label">
                Full Name<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your full name"
                className="p-3 rounded-4 font-padding-react-to theme-shadow"
                name="name"
                {...formik.getFieldProps("name")}
                onKeyDown={(e) => {
                  if (!/^[a-zA-Z\s]$/.test(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
                isInvalid={formik.touched.name && formik.errors.name}
              />
              <Form.Control.Feedback type="invalid" className="ms-3">
                {formik.errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-sm-3 mt-md-1">
            <Form.Group controlId="formPhone">
              <Form.Label className="reatch-us-form-label">
                Phone Number<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your phone number"
                className="p-3 rounded-4 font-padding-react-to theme-shadow"
                name="phone_number"
                {...formik.getFieldProps("phone_number")}
                isInvalid={
                  formik.touched.phone_number && formik.errors.phone_number
                }
                inputMode="numeric"
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  formik.setFieldValue("phone_number", value);
                }}
              />
              <Form.Control.Feedback type="invalid" className="ms-3">
                {formik.errors.phone_number}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-3 px-0">
          <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6} className="mt-1">
            <Form.Group controlId="formEmail">
              <Form.Label className="reatch-us-form-label">Email ID<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email ID"
                className="p-3 rounded-4 font-padding-react-to theme-shadow"
                name="email"
                {...formik.getFieldProps("email")}
                isInvalid={formik.touched.email && formik.errors.email}
              />
              <Form.Control.Feedback type="invalid" className="ms-3">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-sm-3 mt-md-1">
            <Form.Group controlId="formCity">
              <Form.Label className="reatch-us-form-label">City<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your city"
                className="p-3 rounded-4 font-padding-react-to theme-shadow"
                name="city"
                {...formik.getFieldProps("city")}
                isInvalid={formik.touched.city && formik.errors.city}
              />
              <Form.Control.Feedback type="invalid" className="ms-3">
                {formik.errors.city}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group controlId="formMessage" className="p-2 pt-0 mt-3">
          <Form.Label className="reatch-us-form-label">Message<span className="text-danger">*</span></Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your message"
            className="rounded-4 retch-place-msg theme-shadow"
            name="message"
            {...formik.getFieldProps("message")}
            isInvalid={formik.touched.message && formik.errors.message}
          />
          <Form.Control.Feedback type="invalid" className="ms-3">
            {formik.errors.message}
          </Form.Control.Feedback>
        </Form.Group>
        {/* <div className="d-flex justify-content-end"> */}
        <div className="reach-us-btn">
          <button
            className="btn-red-to-black-color-move rounded-4 mt-3 px-4 py-2 reachus-btn"
            type="submit"
          >
            <span>Submit</span>
          </button>
        </div>
        {formik.status && formik.status.success && (
          <Alert variant="success" className="mt-3">
            {formik.status.success}
          </Alert>
        )}
        {formik.status && formik.status.error && (
          <Alert variant="danger" className="mt-3">
            {formik.status.error}
          </Alert>
        )}
      </Form>
    </Col>
  );
};
